import React, { useContext, useState } from 'react'
import UserContext, { Roles } from '../../../UserContext'
import TabMenu, { TabMenuTabsProps } from '../../Common/TabMenu'
import Detail from './Detail'
import { ServiceRequestService } from '../../../models'
import PopoutHeading from '../../Common/PopoutHeading'
import ViewResponses from '../Responses/ViewResponses'
import { ServiceRequestContext } from '../ServiceRequestContext'
import CommentsPane from '../Comments/CommentsPane'
import ViewAudits from '../../Common/ViewAudits'
import ViewReadReceipts from '../ReadReceipts/ViewReadReceipts'
import ProviderSearch from '../ProviderSearch/ProviderSearch'

const ServicePane: React.FC = () => {
    const userContext = useContext(UserContext)
    const { selectedService, isSearchOpportunities } = useContext(ServiceRequestContext)
    const [activeTab, setActiveTab] = useState('Details')
    const hideIdentifierForProviderInSearch = isSearchOpportunities && userContext.hasAnyRole(Roles.Provider)
    const identifier = hideIdentifierForProviderInSearch
        ? undefined
        : (isSearchOpportunities
            ? selectedService?.serviceRequestServiceID
            : (selectedService?.displayIdentifier || selectedService?.serviceRequestServiceID))

    const tabs: TabMenuTabsProps = [
        {
            title: 'Details',
            component: <Detail serviceRequestService={selectedService as ServiceRequestService} />
        },
        ...selectedService ? [
            {
                title: 'Responses',
                hideForRoles: [Roles.Provider],
                component: (
                    <>
                        <ViewResponses service={selectedService} />
                        <ViewReadReceipts service={selectedService} />
                    </>
                )
            },
            {
                title: 'Changes',
                hideForRoles: [Roles.Provider],
                component: (
                    <ViewAudits
                        objectType='ServiceRequestService'
                        objectID={selectedService?.serviceRequestServiceID ?? 0}
                        activeTab={activeTab}
                    />
                )
            },
            {
                title: 'Search',
                showForRoles: [Roles.MarketAdmin, Roles.WaiverServiceLeader],
                component: <ProviderSearch isActive={activeTab === 'Search'}></ProviderSearch>
            },
            ...(!isSearchOpportunities ? [{
                title: 'Comments',
                component: <CommentsPane ></CommentsPane>
            }] : [])
        ] : []
    ]

    return (
        <>
            <PopoutHeading
                mainTitle='Service Posting'
                subTitle={!selectedService ? 'New' : activeTab}
                identifier={identifier}
            />

            <TabMenu title='Service Posting' tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} searchIndex='tab' />
        </>
    )
}

export default ServicePane
